import type { ReactNode } from 'react';
import s from './auth-shell.module.css';
import { BuildStamp } from './build-stamp';
import { useHeaderActions } from './header-actions';

export interface AuthImage {
  src: string;
  /** Shown over the photo, bottom left. */
  caption: ReactNode;
  /** Photographer credit, e.g. "Photo: cottonbro studio / Pexels". */
  credit: string;
}

/**
 * Sign-in and account setup: a large photo on the left, the form on the right. Below 900 px
 * the photo is dropped and the page reads like the other public pages.
 */
export function AuthShell({ image, children }: { image: AuthImage; children: ReactNode }) {
  const actions = useHeaderActions();
  return (
    <div className={s.split}>
      <aside className={s.art} style={{ backgroundImage: `url(${image.src})` }}>
        <div className={s.shade} />
        <div className={s.caption}>
          <span className={s.eyebrow}>Cancer Expert Now</span>
          <p>{image.caption}</p>
          <span className={s.credit}>{image.credit}</span>
        </div>
      </aside>
      <div className={s.side}>
        <header className={s.top}>
          <span className={s.brand}>Concord</span>
          <span className={s.cen}>Cancer Expert Now</span>
          {actions && <span className={s.actions}>{actions}</span>}
        </header>
        <main className={s.form}>
          {children}
          <BuildStamp />
        </main>
      </div>
    </div>
  );
}
